import React from "react";
import SidebarDistrict from "../components/district/sidebarDistric";
import { Outlet } from "react-router-dom";

export default function DistrictLayout() {
  return (
    <div className="d-flex flex-column flex-lg-row" style={{ minHeight: "100vh" }}>
      <SidebarDistrict />
      <main className="flex-grow-1 p-3">
        <div className="d-lg-none" style={{ height: "60px" }}></div>
        <Outlet />
      </main>
    </div>
  );
}
